import React, { useId } from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconGradientRightCardGroup: React.FC<SvgProps> = (props) => {
  const stopColor = toSvgColor('currentColor', props);
  const id = useId();

  return (
    <g fill="none" {...(props.group ?? {})}>
      <rect
        width="268"
        height="201"
        transform="matrix(1 0 0 -1 0 201)"
        fill={`url(#${id}_fill)`}
      />
      <defs>
        <radialGradient
          id={`${id}_fill`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(763.257 170.5) rotate(-177.959) scale(711.195 231.555)"
        >
          <stop stopColor={stopColor} />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
      </defs>
    </g>
  );
};

export const IconGradientRightCardSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="268"
      height="200"
      viewBox="0 0 268 200"
      {...(props.svg ?? {})}
    >
      <IconGradientRightCardGroup {...props} />
    </svg>
  );
};
